import { render, staticRenderFns } from "./UiHead.vue?vue&type=template&id=3a90c8b7&"
import script from "./UiHead.vue?vue&type=script&lang=js&"
export * from "./UiHead.vue?vue&type=script&lang=js&"
import style0 from "./UiHead.vue?vue&type=style&index=0&id=3a90c8b7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports